import { BaseContainerModel } from '../../base-container.model';
import { bl_fi_mst_item_attribute_set_link_RowClass } from '../../../dbschema/bl_fi_mst_item_attribute_set_link.model';

export class ItemAttributeSetLinkContainerModel extends BaseContainerModel {
  bl_fi_mst_item_attribute_set_link: bl_fi_mst_item_attribute_set_link_RowClass = new bl_fi_mst_item_attribute_set_link_RowClass();
}